import { createContext } from 'react';

export const MenuContext = createContext<Queries.HamburgerMenuFragment>({
  menu: null,
});
